__turbopack_context__.v({
  "container": "nMem7G_container",
  "price": "nMem7G_price",
});
